import { render, staticRenderFns } from "./navMenu.vue?vue&type=template&id=a2498c52&scoped=true&lang=pug"
import script from "./navMenu.vue?vue&type=script&lang=js"
export * from "./navMenu.vue?vue&type=script&lang=js"
import style0 from "./navMenu.vue?vue&type=style&index=0&id=a2498c52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2498c52",
  null
  
)

export default component.exports